import _ from 'lodash'

import { WebEdiDto, WrapperDelFor } from '../../data/models'
import { isEmpty } from '../../utils/helper/isEmpty'
import { configMapping } from './configMapping'

export interface CheckFieldOptions {
  requiredFieldPath: string
  orderPosition?: string
}

export function getMissingFieldsFromData(
  requiredFieldPaths: string[],
  data: WebEdiDto | WrapperDelFor,
): CheckFieldOptions[] | null {
  const missingFields: CheckFieldOptions[] = []

  function checkFieldForEmpty(path: string, options: CheckFieldOptions) {
    const value = _.get(data, path)

    if (isEmpty(value)) {
      missingFields.push(options)
    }
  }

  function processRequiredField(requiredFieldPath: string) {
    const mappingPath = configMapping[requiredFieldPath]
    const searchSubstring = '[index]'

    if (mappingPath?.includes(searchSubstring)) {
      processNestedFields(mappingPath, requiredFieldPath)
    } else {
      checkFieldForEmpty(mappingPath, { requiredFieldPath })
    }
  }

  function processNestedFields(
    mappingPath: string,
    requiredFieldPath: string,
    basePath: string = '',
    indices: number[] = [],
  ) {
    const searchSubstring = '[index]'
    const indexStart = mappingPath.indexOf(searchSubstring)
    const indexEnd = indexStart + searchSubstring.length

    const firstString = mappingPath.substring(0, indexStart)
    const secondString = mappingPath.substring(indexEnd)

    const itemsPath = basePath + firstString
    const items = _.get(data, itemsPath)

    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        const currentPath = `${itemsPath}[${i}]`

        if (secondString.includes(searchSubstring)) {
          processNestedFields(secondString, requiredFieldPath, currentPath, [
            ...indices,
            i,
          ])
        } else {
          const finalPath = currentPath + secondString
          const isRejected =
            _.get(data, `${currentPath}.ConfirmationCode`) === 'REJECTED'
          const orderPosition = _.get(data, `${currentPath}.OrderPosition`)

          if (!isRejected) {
            checkFieldForEmpty(finalPath, {
              requiredFieldPath,
              orderPosition,
            })
          }
        }
      }
    }
  }

  requiredFieldPaths.forEach(processRequiredField)

  return missingFields.length ? missingFields : null
}
